<template>
  <div>
    <Button
      id="remove-payment-settings"
      :class="`${ButtonSeverityClass.SECONDARY} ${ButtonStateClass.OUTLINE} border-none`"
      :label="translate(`${LOCALE_PREFIX}.actions.removePaymentSettings`)"
      @click.stop="openDeleteConfirmation"
      v-if="hasPaymentConfig && editPaymentInfo"
    >
      <template #icon>
        <i class="material-symbols-rounded text-2xl mr-2">delete</i>
      </template>
    </Button>

    <DeleteConfirmation v-model="showDeleteConfirmation" />
  </div>
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { ref } from 'vue';
import { usePaymentInfo } from '../../composables';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '@centric-os/sites/src/routes';
import { SitesLocalePrefix } from '@centric-os/sites/src/enums';
import DeleteConfirmation from './delete-confirmation/DeleteConfirmation.vue';
import { ButtonSeverityClass, ButtonStateClass } from '@/components';

// Since this component is only used for station config, we don't need the isSiteConfig prop

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_PAYMENT_INFO;

// Ref for show delete confirmation
const showDeleteConfirmation = ref<boolean>(false);

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editPaymentInfo } = storeToRefs(fConfigStore);

// Set payment info composable
const { hasPaymentConfig } = usePaymentInfo();

// Method to open delete confirmation
const openDeleteConfirmation = (): void => {
  showDeleteConfirmation.value = true;
};
</script>
